import { AlertDialog, AlertDialogOverlay, AlertDialogContent, Flex, AlertDialogBody, Button, Text, useColorModeValue } from "@chakra-ui/react";
import { useRef, useState } from "react";

export const useUpdateTradeLogicBulk = ({ }: any): [(trades: number[], condition: string) => Promise<string>, () => JSX.Element] => {

    const [promise, setPromise] = useState<{ resolve: (value: string) => void } | null>(null);
    const cancelRef = useRef();

    const textColor = useColorModeValue('secondaryGray.700', 'white');
    const [loading, setLoading] = useState(false);

    async function bulkUpdate(trades: number[], condition: string): Promise<string> {
        return new Promise(async (resolve, reject) => {
            setPromise({ resolve });
        });
    }

    const handleConfirm = async () => {
        setLoading(true);
        promise?.resolve('update');//commission);
        handleClose();
    }

    const handleCancel = () => {
        promise?.resolve('cancel');//commission);
        handleClose();
    }

    const handleClose = () => {
        setPromise(null);
        setLoading(false);
    }

    const LogicBulkUpdateConfirm = () => {
        return (
            <>
                <AlertDialog leastDestructiveRef={cancelRef} isOpen={promise !== null} onClose={handleCancel} motionPreset='slideInBottom' closeOnOverlayClick={false}>
                    <AlertDialogOverlay>
                        <AlertDialogContent>
                            <AlertDialogBody>
                                <Text color={textColor} fontWeight={'700'} mt='30px' mb='20px'>
                                    UPDATE this market condition in all of today's trades?
                                </Text>
                                <Flex direction={'row'} justify={'end'} mt='30px' mb='20px'>
                                    <Button ref={cancelRef} onClick={handleCancel}>
                                        NO, thanks!
                                    </Button>
                                    <Button onClick={handleConfirm} colorScheme='teal' ml={3} isDisabled={loading} isLoading={loading} loadingText="Processing">
                                        Yes please!
                                    </Button>
                                </Flex>
                            </AlertDialogBody>
                        </AlertDialogContent>
                    </AlertDialogOverlay>
                </AlertDialog>
            </>
        )
    };

    return [bulkUpdate, LogicBulkUpdateConfirm];
}